import script from "./OnboardingAiInviteUsersEmailInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiInviteUsersEmailInvitation.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiInviteUsersEmailInvitation.vue?vue&type=style&index=0&id=b584b1a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b584b1a2"]])

export default __exports__